"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deferMiddleware;

/* eslint-disable no-unused-vars */
function deferMiddleware(opts) {
  var middleware = function middleware(next) {
    return function (req) {
      return next(req);
    };
  };

  middleware.supports = ['defer'];
  return middleware;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-relay-network-layer/lib/middleware/defer.js
// module id = 2220
// module chunks = 0